import DeleteButton from './DeleteButton';
import DeleteButtonContainer from './DeleteButton.container';
export default DeleteButtonContainer(DeleteButton);
//# sourceMappingURL=index.js.map